import { Component } from '@angular/core';

@Component( {
    selector: 'app-experience',
    templateUrl: './experience.component.html',
    styleUrls: [ './experience.component.css' ],
    standalone: false
} )
export class ExperienceComponent { }

